export default __webpack_public_path__ + "static/acf-logo-a85f94a51dadcac3a2586f2e15af80d5.png";